import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { useAuth0 } from "@auth0/auth0-react";
import { CircularProgress } from "@material-ui/core";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import Footer from "../Footer";
import Home from "../Home";
import Content from "../Content";
import OurApproach from "../OurApproach";
import Contact from "../Contact";
import { ROUTES } from "../routes";
import AppBarComponent from "ui/compounds/AppBar/AppBarComponent";
const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    maxWidth: "1920px",
    margin: "auto",
    height: "auto",
    display: "flex",
    flexDirection: "column",
    backgroundColor: theme.palette.background.default,
    overscrollBehavior: "none", // disables pull-to-refresh
  },
}));
const UnAuthenticatedHome = () => {
  const classes = useStyles();
  const { isLoading } = useAuth0();
  if (isLoading) {
    return (
      <div>
        <CircularProgress />
      </div>
    );
  }
  return (
    <Router>
      <div className={classes.root}>
        <Switch>
          <Route path={ROUTES.home}>
            <AppBarComponent changeOnScroll={true} />
            <Home />
          </Route>
          <Route path={ROUTES.learn}>
            <AppBarComponent changeOnScroll={true} />
            <Content />
          </Route>
          <Route path={ROUTES.ourApproach}>
            <AppBarComponent changeOnScroll={true} />
            <OurApproach />
          </Route>
          <Route path={ROUTES.contact}>
            <AppBarComponent changeOnScroll={true} />
            <Contact />
          </Route>
          <Redirect to={ROUTES.home} />
        </Switch>
        <Footer />
      </div>
    </Router>
  );
};

export default UnAuthenticatedHome;
